<div class="w-full mx-auto p-5">
  <form [formGroup]="refundForm" (ngSubmit)="onSubmit()" class="space-y-6">

    <!-- Header -->
    <div class="bg-white p-6 rounded-lg shadow-sm">
      <h1 class="text-2xl font-bold text-gray-800">Nueva Devolución</h1>
      <p class="text-gray-500 mt-1">Seleccione el tipo de inscripción, devolución y complete la información requerida
      </p>
    </div>

    <!-- Selector de Tipo de Inscripción -->
    <div class="bg-white p-6 rounded-lg shadow-sm">
      <h2 class="text-lg font-semibold text-gray-800 mb-4">Tipo de Inscripción</h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div *ngFor="let type of enrollmentTypes" class="border-2 rounded-lg p-4 cursor-pointer transition-all"
          [ngClass]="{
               'border-green-500 bg-green-50': refundForm.get('enrollmentType')?.value === type.value,
               'border-gray-200 hover:border-gray-300': refundForm.get('enrollmentType')?.value !== type.value
             }" (click)="refundForm.get('enrollmentType')?.setValue(type.value)">

          <div class="flex items-center mb-2">
            <input type="radio" [value]="type.value" formControlName="enrollmentType"
              class="text-green-600 focus:ring-green-500">
            <label class="ml-2 text-sm font-medium text-gray-900">{{ type.label }}</label>
          </div>
          <p class="text-xs text-gray-500">{{ type.description }}</p>
        </div>
      </div>

      <div *ngIf="refundForm.get('enrollmentType')?.invalid && refundForm.get('enrollmentType')?.touched"
        class="text-red-500 text-sm mt-2">
        Debe seleccionar un tipo de inscripción
      </div>
    </div>

    <!-- Selector de Tipo de Devolución -->
    <div *ngIf="selectedEnrollmentType" class="bg-white p-6 rounded-lg shadow-sm">
      <h2 class="text-lg font-semibold text-gray-800 mb-4">Tipo de Devolución</h2>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div *ngFor="let type of refundTypes" class="border-2 rounded-lg p-4 cursor-pointer transition-all" [ngClass]="{
               'border-blue-500 bg-blue-50': refundForm.get('refundType')?.value === type.value,
               'border-gray-200 hover:border-gray-300': refundForm.get('refundType')?.value !== type.value
             }" (click)="refundForm.get('refundType')?.setValue(type.value)">

          <div class="flex items-center mb-2">
            <input type="radio" [value]="type.value" formControlName="refundType"
              class="text-blue-600 focus:ring-blue-500">
            <label class="ml-2 text-sm font-medium text-gray-900">{{ type.label }}</label>
          </div>
          <p class="text-xs text-gray-500">{{ type.description }}</p>
        </div>
      </div>

      <div *ngIf="refundForm.get('refundType')?.invalid && refundForm.get('refundType')?.touched"
        class="text-red-500 text-sm mt-2">
        Debe seleccionar un tipo de devolución
      </div>
    </div>

    <!-- Información Corporativa -->
    <div *ngIf="selectedRefundType && selectedEnrollmentType === 'corporate'" class="bg-white p-6 rounded-lg shadow-sm">
      <h2 class="text-lg font-semibold text-gray-800 mb-4">Información Corporativa</h2>

      <!-- Selector de Tipo de Pagador -->
      <div class="mb-6">
        <h3 class="text-md font-medium text-gray-700 mb-3">Tipo de Pagador</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div *ngFor="let type of payerTypes" class="border-2 rounded-lg p-3 cursor-pointer transition-all" [ngClass]="{
                 'border-purple-500 bg-purple-50': refundForm.get('payerType')?.value === type.value,
                 'border-gray-200 hover:border-gray-300': refundForm.get('payerType')?.value !== type.value
               }" (click)="refundForm.get('payerType')?.setValue(type.value)">

            <div class="flex items-center mb-1">
              <input type="radio" [value]="type.value" formControlName="payerType"
                class="text-purple-600 focus:ring-purple-500">
              <label class="ml-2 text-sm font-medium text-gray-900">{{ type.label }}</label>
            </div>
            <p class="text-xs text-gray-500">{{ type.description }}</p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Empresa -->
        <div>
          <label for="companyId" class="block text-sm font-medium text-gray-700 mb-1">
            Empresa <span class="text-red-500">*</span>
          </label>
          <p-dropdown [options]="companies" formControlName="companyId" placeholder="Seleccione una empresa"
            [filter]="true" filterBy="label" optionLabel="label" optionValue="value" [showClear]="true"
            [loading]="isLoadingCompanies" (onFilter)="onSearchCompanies($event)" class="w-full custom-dropdown">
          </p-dropdown>
          <div *ngIf="refundForm.get('companyId')?.invalid && refundForm.get('companyId')?.touched"
            class="text-red-500 text-sm mt-1">
            Empresa es requerida
          </div>
        </div>

        <!-- Inscripción Corporativa -->
        <div>
          <label for="corporateEnrollmentId" class="block text-sm font-medium text-gray-700 mb-1">
            Inscripción Corporativa <span class="text-red-500">*</span>
          </label>
          <p-dropdown [options]="corporateEnrollments" formControlName="corporateEnrollmentId"
            placeholder="Seleccione una inscripción corporativa" [filter]="true" filterBy="label" optionLabel="label"
            optionValue="value" [showClear]="true" [loading]="isLoadingCorporateEnrollments"
            [disabled]="!selectedCompany" class="w-full custom-dropdown">
          </p-dropdown>
          <div
            *ngIf="refundForm.get('corporateEnrollmentId')?.invalid && refundForm.get('corporateEnrollmentId')?.touched"
            class="text-red-500 text-sm mt-1">
            Inscripción corporativa es requerida
          </div>
        </div>

        <!-- Participante Corporativo (solo si el tipo de pagador es PARTICIPANT_CORPORATE) -->
        <div *ngIf="selectedPayerType === 'PARTICIPANT_CORPORATE'" class="md:col-span-2">
          <label for="corporateParticipantId" class="block text-sm font-medium text-gray-700 mb-1">
            Participante Corporativo <span class="text-red-500">*</span>
          </label>
          <p-dropdown [options]="corporateParticipants" formControlName="corporateParticipantId"
            placeholder="Seleccione un participante corporativo" [filter]="true" filterBy="label" optionLabel="label"
            optionValue="value" [showClear]="true" [loading]="isLoadingCorporateParticipants"
            [disabled]="!selectedCorporateEnrollment" class="w-full custom-dropdown">
          </p-dropdown>
          <div
            *ngIf="refundForm.get('corporateParticipantId')?.invalid && refundForm.get('corporateParticipantId')?.touched"
            class="text-red-500 text-sm mt-1">
            Participante corporativo es requerido
          </div>
        </div>
      </div>

      <!-- Información de la empresa seleccionada -->
      <div *ngIf="selectedCompany" class="mt-4 bg-purple-50 p-3 rounded-lg border border-purple-200">
        <h3 class="text-sm font-medium text-purple-800 mb-2">Información de la Empresa</h3>
        <div class="text-sm text-purple-700">
          <p><strong>Empresa:</strong> {{ selectedCompany.name }}</p>
          <p><strong>Documento:</strong> {{ selectedCompany.documentId }}</p>
          <p><strong>Email:</strong> {{ selectedCompany.email }}</p>
        </div>
      </div>

      <!-- Información de la inscripción corporativa seleccionada -->
      <div *ngIf="selectedCorporateEnrollment" class="mt-4 bg-blue-50 p-3 rounded-lg border border-blue-200">
        <h3 class="text-sm font-medium text-blue-800 mb-2">Información de la Inscripción Corporativa</h3>
        <div class="text-sm text-blue-700">
          <p><strong>Proyecto:</strong> {{ selectedCorporateEnrollment.project?.projectId }} - {{
            selectedCorporateEnrollment.project?.name }}</p>
          <p><strong>Modalidad:</strong> {{ selectedCorporateEnrollment.coverageModality === 1 ? 'Total' : 'Parcial' }}
          </p>
          <p><strong>Participantes:</strong> {{ corporateParticipants.length }}</p>
        </div>
      </div>

      <!-- Información del participante corporativo seleccionado -->
      <div *ngIf="selectedCorporateParticipant && selectedPayerType === 'PARTICIPANT_CORPORATE'"
        class="mt-4 bg-green-50 p-3 rounded-lg border border-green-200">
        <h3 class="text-sm font-medium text-green-800 mb-2">Información del Participante Corporativo</h3>
        <div class="text-sm text-green-700">
          <p><strong>Nombre:</strong> {{ selectedCorporateParticipant.firstName }} {{
            selectedCorporateParticipant.lastName }}</p>
          <p><strong>Documento:</strong> {{ selectedCorporateParticipant.documentId }}</p>
          <p><strong>Email:</strong> {{ selectedCorporateParticipant.email }}</p>
        </div>
      </div>

      <!-- Mensaje de validación de inscripciones corporativas -->
      <div *ngIf="companyHasEnrollments === false && refundForm.get('companyId')?.value"
        class="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
        <div class="flex items-start">
          <svg class="w-5 h-5 text-red-500 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293z"
              clip-rule="evenodd"></path>
          </svg>
          <div>
            <p class="text-sm font-semibold text-red-800">⚠️ Sin inscripciones corporativas</p>
            <p class="text-xs text-red-600 mt-1">{{ companyEnrollmentCheckMessage }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Información del Participante y Proyecto (para inscripciones individuales) -->
    <div *ngIf="selectedRefundType && selectedEnrollmentType === 'individual'"
      class="bg-white p-6 rounded-lg shadow-sm">
      <h2 class="text-lg font-semibold text-gray-800 mb-4">Información del Participante</h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Participante/Estudiante -->
        <div>
          <label for="participantId" class="block text-sm font-medium text-gray-700 mb-1">
            Participante/Estudiante <span class="text-red-500">*</span>
          </label>
          <p-dropdown [options]="participants" formControlName="participantId" placeholder="Seleccione un participante"
            [filter]="true" filterBy="label" optionLabel="label" optionValue="value" [showClear]="true"
            [loading]="isLoadingParticipants" (onFilter)="onSearchParticipants($event)" class="w-full custom-dropdown">
          </p-dropdown>
          <div *ngIf="refundForm.get('participantId')?.invalid && refundForm.get('participantId')?.touched"
            class="text-red-500 text-sm mt-1">
            Participante es requerido
          </div>
        </div>

        <!-- Proyecto -->
        <div>
          <label for="projectId" class="block text-sm font-medium text-gray-700 mb-1">
            Proyecto <span class="text-red-500">*</span>
          </label>
          <p-dropdown [options]="projects" formControlName="projectId" placeholder="Seleccione un proyecto"
            [filter]="true" filterBy="label" optionLabel="label" optionValue="value" [showClear]="true"
            [loading]="isLoadingProjects" [disabled]="!selectedParticipant" class="w-full custom-dropdown">
          </p-dropdown>
          <div *ngIf="refundForm.get('projectId')?.invalid && refundForm.get('projectId')?.touched"
            class="text-red-500 text-sm mt-1">
            Proyecto es requerido
          </div>
        </div>
      </div>

      <!-- Información del participante seleccionado -->
      <div *ngIf="selectedParticipant" class="mt-4 bg-blue-50 p-3 rounded-lg border border-blue-200">
        <h3 class="text-sm font-medium text-blue-800 mb-2">Información del Participante</h3>
        <div class="text-sm text-blue-700">
          <p><strong>Nombre:</strong> {{ selectedParticipant.firstName }} {{ selectedParticipant.lastName }}</p>
          <p><strong>Documento:</strong> {{ selectedParticipant.documentId }}</p>
          <p><strong>Email:</strong> {{ selectedParticipant.email }}</p>
        </div>
      </div>

      <!-- Mensaje de validación de inscripciones para participante individual -->
      <div *ngIf="participantHasEnrollments === false && refundForm.get('participantId')?.value"
        class="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
        <div class="flex items-start">
          <svg class="w-5 h-5 text-red-500 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293z"
              clip-rule="evenodd"></path>
          </svg>
          <div>
            <p class="text-sm font-semibold text-red-800">⚠️ Sin inscripciones</p>
            <p class="text-xs text-red-600 mt-1">{{ participantEnrollmentCheckMessage }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Sección específica para Devolución de Excedente -->
    <div
      *ngIf="isExcessRefund && ((selectedEnrollmentType === 'individual' && selectedParticipant && refundForm.get('projectId')?.value) || 
                                 (selectedEnrollmentType === 'corporate' && selectedCorporateEnrollment && ((selectedPayerType === 'COMPANY') || (selectedPayerType === 'PARTICIPANT_CORPORATE' && selectedCorporateParticipant))))"
      class="bg-white p-6 rounded-lg shadow-sm">
      <h2 class="text-lg font-semibold text-gray-800 mb-4">Selección de Excedente</h2>

      <div class="bg-yellow-50 p-4 rounded-lg border border-yellow-200 mb-4">
        <p class="text-sm text-yellow-800">
          <strong>Devolución de Excedente:</strong> Seleccione el excedente de pago que desea devolver.
        </p>
      </div>

      <!-- Lista de Excedentes Disponibles -->
      <div class="bg-gray-50 p-4 rounded-lg">
        <div class="flex justify-between items-center mb-3">
          <h4 class="text-md font-medium text-gray-700">Excedentes Disponibles</h4>
        </div>

        <!-- Lista de excedentes disponibles -->
        <div *ngIf="availableExcesses.length > 0" class="space-y-2 mb-3">
          <div *ngFor="let excess of availableExcesses; let i = index"
            class="bg-white p-3 rounded border cursor-pointer hover:bg-gray-50"
            [ngClass]="{ 'border-blue-500 bg-blue-50': selectedExcess?.id === excess.id }"
            (click)="selectExcess(excess)">
            <div class="flex justify-between items-center">
              <div>
                <span class="font-medium">Excedente #{{ excess.id }}</span>
                <span class="text-gray-500 ml-2">{{ excess.createdDate | date:'shortDate' }}</span>
              </div>
              <div class="flex items-center gap-3">
                <span class="font-semibold text-green-700">{{ excess.excessAmount | currency }}</span>
                <input type="radio" [checked]="selectedExcess?.id === excess.id" class="text-blue-600">
              </div>
            </div>
            <div class="text-xs text-gray-600 mt-1">
              Origen: {{ excess.originDescription }}
            </div>
          </div>
        </div>

        <!-- Mensaje cuando no hay excedentes -->
        <div *ngIf="availableExcesses.length === 0" class="text-gray-500 text-center py-4">
          <!-- Mensajes para inscripciones individuales -->
          <div
            *ngIf="selectedEnrollmentType === 'individual' && (!refundForm.get('participantId')?.value || !refundForm.get('projectId')?.value)">
            Seleccione un participante y proyecto para ver excedentes disponibles
          </div>
          <div
            *ngIf="selectedEnrollmentType === 'individual' && refundForm.get('participantId')?.value && refundForm.get('projectId')?.value">
            No hay excedentes disponibles para este participante y proyecto
          </div>

          <!-- Mensajes para inscripciones corporativas -->
          <div *ngIf="selectedEnrollmentType === 'corporate' && (!selectedCorporateEnrollment || !selectedPayerType)">
            Seleccione una inscripción corporativa y tipo de pagador para ver excedentes disponibles
          </div>
          <div
            *ngIf="selectedEnrollmentType === 'corporate' && selectedCorporateEnrollment && selectedPayerType && selectedPayerType === 'PARTICIPANT_CORPORATE' && !selectedCorporateParticipant">
            Seleccione un participante corporativo para ver excedentes disponibles
          </div>
          <div
            *ngIf="selectedEnrollmentType === 'corporate' && selectedCorporateEnrollment && selectedPayerType && ((selectedPayerType === 'COMPANY') || (selectedPayerType === 'PARTICIPANT_CORPORATE' && selectedCorporateParticipant))">
            No hay excedentes corporativos disponibles para esta configuración
          </div>
        </div>

        <!-- Excedente seleccionado -->
        <div *ngIf="selectedExcess" class="border-t pt-3">
          <div class="flex justify-between items-center font-semibold mb-2">
            <span>Excedente seleccionado:</span>
            <span class="text-lg text-blue-700">{{ selectedExcess.excessAmount | currency }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Sección específica para Devolución de Plan - REFACTORIZADO -->
    <div
      *ngIf="isPlanRefund && ((selectedEnrollmentType === 'individual' && selectedParticipant && refundForm.get('projectId')?.value) || 
                                (selectedEnrollmentType === 'corporate' && selectedCorporateEnrollment && ((selectedPayerType === 'COMPANY') || (selectedPayerType === 'PARTICIPANT_CORPORATE' && selectedCorporateParticipant))))"
      class="bg-white p-6 rounded-lg shadow-sm">
      <h2 class="text-lg font-semibold text-gray-800 mb-4">Devolución de Plan de Pagos</h2>

      <!-- Mensaje informativo sobre el nuevo flujo -->
      <div class="bg-green-50 p-4 rounded-lg border border-green-200 mb-4">
        <p class="text-sm text-green-800">
          <strong>Devolución de Plan:</strong> Ingrese el monto a devolver y el sistema distribuirá automáticamente
          el valor entre las cuotas pagadas, empezando por la última cuota y retrocediendo hacia las anteriores.
        </p>
        <p class="text-xs text-green-600 mt-2" *ngIf="!isRetractRightActive">
          <i class="pi pi-info-circle mr-1"></i>
          El monto máximo permitido es el 80% del valor total de la inscripción.
        </p>
        <p class="text-xs text-blue-600 mt-2" *ngIf="isRetractRightActive">
          <i class="pi pi-check-circle mr-1"></i>
          Con derecho al retracto: El monto máximo permitido es el 100% del valor total de la inscripción.
        </p>
      </div>

      <!-- Checkbox para Derecho al Retracto -->
      <div class="bg-blue-50 p-4 rounded-lg border border-blue-200 mb-4">
        <div class="flex items-start">
          <div class="flex items-center h-5">
            <input id="useRetractRight" type="checkbox" formControlName="useRetractRight"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2">
          </div>
          <div class="ml-3 text-sm">
            <label for="useRetractRight" class="font-medium text-blue-800 cursor-pointer">
              Usar derecho al retracto
            </label>
            <p class="text-blue-600 mt-1">
              Permite devoluciones del 100% del valor de la inscripción en lugar del límite estándar del 80%.
              Aplica para casos de retracto legal, cancelaciones especiales o correcciones administrativas.
            </p>
          </div>
        </div>
      </div>

      <!-- Panel de información de límites de devolución -->
      <div class="bg-gray-50 p-4 rounded-lg">
        <div class="flex justify-between items-center mb-4">
          <h4 class="text-md font-medium text-gray-700">Límites de Devolución</h4>
          <div *ngIf="isLoadingPlanLimits" class="flex items-center text-gray-500">
            <i class="pi pi-spin pi-spinner mr-2"></i>
            Calculando límites...
          </div>
        </div>

        <!-- Información de límites cuando está cargada -->
        <div *ngIf="planRefundLimits && !isLoadingPlanLimits" class="space-y-3">
          <!-- Valor total de la inscripción -->
          <div class="flex justify-between items-center p-3 bg-white rounded border">
            <div class="flex items-center">
              <i class="pi pi-wallet text-blue-500 mr-2"></i>
              <span class="text-gray-700">Valor total de la inscripción</span>
            </div>
            <div class="text-right">
              <span class="font-semibold text-gray-800">{{ planRefundLimits.totalAmount |
                currency:planRefundLimits.currencyCode }}</span>
              <span *ngIf="planRefundLimits.currencyCode !== 'COP'" class="text-xs text-gray-500 block">
                Moneda: {{ planRefundLimits.currencyCode }}
              </span>
            </div>
          </div>

          <!-- Máximo permitido (80%) -->
          <div class="flex justify-between items-center p-3 bg-white rounded border" 
               [ngClass]="{'opacity-50': isRetractRightActive}">
            <div class="flex items-center">
              <i class="pi pi-percentage text-orange-500 mr-2"></i>
              <span class="text-gray-700">Máximo permitido estándar ({{ planRefundLimits.maxRefundPercentage * 100 }}%)</span>
            </div>
            <span class="font-semibold text-orange-600">{{ planRefundLimits.maxRefundable |
              currency:planRefundLimits.currencyCode }}</span>
          </div>

          <!-- Máximo permitido con derecho al retracto (100%) -->
          <div *ngIf="planRefundLimits.canUseRetractRight" 
               class="flex justify-between items-center p-3 rounded border-2"
               [ngClass]="{
                 'bg-blue-50 border-blue-500': isRetractRightActive,
                 'bg-white border-gray-200': !isRetractRightActive
               }">
            <div class="flex items-center">
              <i class="pi pi-star text-blue-500 mr-2"></i>
              <span class="font-medium" [ngClass]="{
                'text-blue-700': isRetractRightActive,
                'text-gray-700': !isRetractRightActive
              }">Máximo con derecho al retracto (100%)</span>
            </div>
            <span class="font-bold text-lg" [ngClass]="{
              'text-blue-700': isRetractRightActive,
              'text-gray-600': !isRetractRightActive
            }">{{ planRefundLimits.maxRefundableWithRetractRight |
              currency:planRefundLimits.currencyCode }}</span>
          </div>

          <!-- Total pagado -->
          <div class="flex justify-between items-center p-3 bg-white rounded border">
            <div class="flex items-center">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span class="text-gray-700">Total pagado hasta la fecha</span>
            </div>
            <span class="font-semibold text-green-600">{{ planRefundLimits.totalPaid |
              currency:planRefundLimits.currencyCode }}</span>
          </div>

          <!-- Devoluciones previas -->
          <div *ngIf="planRefundLimits.alreadyRefunded > 0"
            class="flex justify-between items-center p-3 bg-white rounded border">
            <div class="flex items-center">
              <i class="pi pi-replay text-red-500 mr-2"></i>
              <span class="text-gray-700">Devoluciones previas</span>
            </div>
            <span class="font-semibold text-red-600">-{{ planRefundLimits.alreadyRefunded |
              currency:planRefundLimits.currencyCode }}</span>
          </div>

          <!-- Monto disponible para devolver (destacado) -->
          <div class="flex justify-between items-center p-4 rounded border-2" [ngClass]="{
                 'bg-green-50 border-green-500': planRefundLimits.canRefund || (isRetractRightActive && planRefundLimits.availableToRefundWithRetractRight > 0),
                 'bg-blue-50 border-blue-500': isRetractRightActive && planRefundLimits.availableToRefundWithRetractRight > 0,
                 'bg-red-50 border-red-500': !planRefundLimits.canRefund && (!isRetractRightActive || planRefundLimits.availableToRefundWithRetractRight <= 0)
               }">
            <div class="flex items-center">
              <i class="pi pi-dollar mr-2" [ngClass]="{
                   'text-green-600': planRefundLimits.canRefund && !isRetractRightActive,
                   'text-blue-600': isRetractRightActive && planRefundLimits.availableToRefundWithRetractRight > 0,
                   'text-red-600': !planRefundLimits.canRefund && (!isRetractRightActive || planRefundLimits.availableToRefundWithRetractRight <= 0)
                 }"></i>
              <span class="font-medium" [ngClass]="{
                      'text-green-700': planRefundLimits.canRefund && !isRetractRightActive,
                      'text-blue-700': isRetractRightActive && planRefundLimits.availableToRefundWithRetractRight > 0,
                      'text-red-700': !planRefundLimits.canRefund && (!isRetractRightActive || planRefundLimits.availableToRefundWithRetractRight <= 0)
                    }">
                Disponible para devolver
                <span *ngIf="isRetractRightActive" class="text-xs">(con derecho al retracto)</span>
              </span>
            </div>
            <span class="text-xl font-bold" [ngClass]="{
                    'text-green-700': planRefundLimits.canRefund && !isRetractRightActive,
                    'text-blue-700': isRetractRightActive && planRefundLimits.availableToRefundWithRetractRight > 0,
                    'text-red-700': !planRefundLimits.canRefund && (!isRetractRightActive || planRefundLimits.availableToRefundWithRetractRight <= 0)
                  }">
              <span *ngIf="!isRetractRightActive">{{ planRefundLimits.availableToRefund | currency:planRefundLimits.currencyCode }}</span>
              <span *ngIf="isRetractRightActive">{{ planRefundLimits.availableToRefundWithRetractRight | currency:planRefundLimits.currencyCode }}</span>
            </span>
          </div>

          <!-- Información de cuotas -->
          <div class="grid grid-cols-3 gap-2 mt-3">
            <div class="text-center p-2 bg-white rounded border">
              <div class="text-xs text-gray-500">Total Cuotas</div>
              <div class="font-semibold text-gray-800">{{ planRefundLimits.totalInstallments }}</div>
            </div>
            <div class="text-center p-2 bg-white rounded border">
              <div class="text-xs text-gray-500">Cuotas Pagadas</div>
              <div class="font-semibold text-green-600">{{ planRefundLimits.paidInstallments }}</div>
            </div>
            <div class="text-center p-2 bg-white rounded border">
              <div class="text-xs text-gray-500">Elegibles Devolución</div>
              <div class="font-semibold text-blue-600">{{ planRefundLimits.eligibleForRefundInstallments }}</div>
            </div>
          </div>

          <!-- Mensaje cuando no hay monto disponible -->
          <div *ngIf="!planRefundLimits.canRefund" class="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
            <div class="flex items-start">
              <i class="pi pi-exclamation-triangle text-red-500 mr-2 mt-0.5"></i>
              <div>
                <p class="text-sm font-semibold text-red-800">No hay monto disponible para devolución</p>
                <p class="text-xs text-red-600 mt-1">{{ planRefundLimits.message }}</p>
              </div>
            </div>
          </div>

          <!-- Nota informativa sobre distribución automática -->
          <div *ngIf="planRefundLimits.canRefund" class="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <div class="flex items-start">
              <i class="pi pi-info-circle text-blue-500 mr-2 mt-0.5"></i>
              <div>
                <p class="text-sm text-blue-800">
                  <strong>Distribución Automática:</strong> El sistema afectará las cuotas pagadas en orden descendente
                  (última cuota primero) hasta completar el monto solicitado. Las cuotas afectadas se mostrarán en el
                  detalle de la devolución después de crearla.
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Mensaje cuando no hay datos cargados -->
        <div *ngIf="!planRefundLimits && !isLoadingPlanLimits" class="text-gray-500 text-center py-4">
          <i class="pi pi-info-circle text-3xl text-gray-400 mb-2"></i>
          <p class="font-medium">Seleccione un proyecto para ver los límites de devolución</p>
        </div>
      </div>
    </div>

    <!-- Sección específica para Devolución de Servicios -->
    <div
      *ngIf="isServiceRefund && ((selectedEnrollmentType === 'individual' && selectedParticipant && refundForm.get('projectId')?.value) || 
                                   (selectedEnrollmentType === 'corporate' && selectedCorporateEnrollment && ((selectedPayerType === 'COMPANY') || (selectedPayerType === 'PARTICIPANT_CORPORATE' && selectedCorporateParticipant))))"
      class="bg-white p-6 rounded-lg shadow-sm">
      <h2 class="text-lg font-semibold text-gray-800 mb-4">Comprobantes de Servicios</h2>

      <div class="bg-purple-50 p-4 rounded-lg border border-purple-200 mb-4">
        <p class="text-sm text-purple-800">
          <strong>Devolución de Servicios:</strong> Para servicios o conceptos no relacionados con planes de pago o
          excedentes.
        </p>
        <p class="text-xs text-purple-600 mt-1">
          Monto máximo reembolsable: {{ maxRefundableAmount | currency:'COP':'symbol':'1.0-0' }}
        </p>
      </div>

      <!-- Lista de Comprobantes de Ingreso -->
      <div class="bg-gray-50 p-4 rounded-lg">
        <div class="flex justify-between items-center mb-3">
          <h4 class="text-md font-medium text-gray-700">Comprobantes de Servicios Disponibles</h4>

          <!-- Dropdown mejorado para seleccionar comprobantes -->
          <div class="flex items-center gap-2 w-1/2">
            <p-dropdown [options]="availableIncomeReceipts" [(ngModel)]="selectedIncomeReceiptToAdd"
              placeholder="Seleccionar comprobante de servicio" [filter]="true" filterBy="displayLabel"
              optionLabel="displayLabel" optionValue="id" [showClear]="true"
              [disabled]="availableIncomeReceipts.length === 0" (onChange)="onIncomeReceiptSelect($event)"
              class="w-full custom-dropdown">
              <ng-template pTemplate="selectedItem">
                <div *ngIf="getSelectedReceiptForDisplay(); let selectedReceipt">
                  <div class="flex justify-between items-center">
                    <span class="font-medium">{{ selectedReceipt.documentNumber }}</span>
                    <span class="text-green-600 font-semibold">{{ selectedReceipt.grossAmount | currency }}</span>
                  </div>
                </div>
                <div *ngIf="!getSelectedReceiptForDisplay() && selectedIncomeReceiptToAdd">
                  <span class="text-gray-500">Cargando comprobante...</span>
                </div>
              </ng-template>
              <ng-template let-receipt pTemplate="item">
                <div class="flex justify-between items-center w-full p-2">
                  <div class="flex-1">
                    <div class="font-medium">{{ receipt.documentNumber }}</div>
                    <div class="text-xs text-gray-500">
                      Fecha: {{ receipt.documentDate | date:'shortDate' }} •
                      Método: {{ receipt.paymentMethod?.name }} •
                      Banco: {{ receipt.bank?.bankName }}
                    </div>
                    <div class="text-xs text-gray-400">{{ receipt.concept || 'Sin concepto' }}</div>
                  </div>
                  <div class="text-right ml-4">
                    <div class="font-semibold text-green-600">{{ receipt.grossAmount | currency }}</div>
                    <div class="text-xs text-gray-400">ID: {{ receipt.id }}</div>
                  </div>
                </div>
              </ng-template>
            </p-dropdown>
            <button type="button" (click)="addSelectedIncomeReceiptFromDropdown()"
              [disabled]="!selectedIncomeReceiptToAdd"
              class="px-4 py-2 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 disabled:bg-gray-400 whitespace-nowrap">
              <i class="pi pi-plus mr-1"></i>
              Agregar
            </button>
          </div>
        </div>

        <!-- Lista de comprobantes seleccionados -->
        <div *ngIf="selectedIncomeReceipts.length > 0" class="space-y-2 mb-3">
          <div *ngFor="let receipt of selectedIncomeReceipts; let i = index"
            class="flex justify-between items-center bg-white p-3 rounded border">
            <div>
              <span class="font-medium">{{ receipt.documentNumber }}</span>
              <span class="text-gray-500 ml-2">{{ receipt.documentDate | date:'shortDate' }}</span>
              <span class="text-xs text-gray-400 ml-2">ID: {{ receipt.id }}</span>
            </div>
            <div class="flex items-center gap-3">
              <span class="font-semibold text-green-700">{{ receipt.grossAmount | currency }}</span>
              <button type="button" (click)="removeIncomeReceipt(i)"
                class="text-red-600 hover:text-red-800 text-sm px-2 py-1 rounded hover:bg-red-50">
                <i class="pi pi-times mr-1"></i>
                Quitar
              </button>
            </div>
          </div>
        </div>

        <!-- Mensajes informativos -->
        <div *ngIf="availableIncomeReceipts.length === 0 && selectedIncomeReceipts.length === 0"
          class="text-gray-500 text-center py-4">
          <div *ngIf="!refundForm.get('participantId')?.value || !refundForm.get('projectId')?.value">
            Seleccione un participante y proyecto para ver comprobantes de servicios
          </div>
          <div *ngIf="refundForm.get('participantId')?.value && refundForm.get('projectId')?.value">
            <div class="flex flex-col items-center">
              <i class="pi pi-info-circle text-3xl text-gray-400 mb-2"></i>
              <p class="font-medium">No hay comprobantes de servicios disponibles</p>
              <p class="text-sm">Solo se muestran comprobantes no relacionados con planes de pago o excedentes</p>
            </div>
          </div>
        </div>

        <div *ngIf="availableIncomeReceipts.length > 0 && selectedIncomeReceipts.length === 0"
          class="text-gray-500 text-center py-2">
          <i class="pi pi-arrow-up text-blue-500"></i>
          Seleccione comprobantes de servicios para calcular el monto de devolución
        </div>

        <!-- Total y validación -->
        <div *ngIf="selectedIncomeReceipts.length > 0" class="border-t pt-3">
          <div class="flex justify-between items-center font-semibold mb-2">
            <span>Total a devolver:</span>
            <span class="text-lg text-blue-700">{{ getTotalIncomeReceipts() | currency }}</span>
          </div>

          <!-- Validación contra monto máximo -->
          <div *ngIf="maxRefundableAmount > 0 && getTotalIncomeReceipts() > maxRefundableAmount"
            class="text-red-600 text-sm">
            ⚠️ El monto total excede el máximo reembolsable ({{ maxRefundableAmount | currency }})
          </div>
        </div>
      </div>
    </div>

    <!-- Información de la Devolución (común para todos los tipos) -->
    <div
      *ngIf="selectedRefundType && ((selectedEnrollmentType === 'individual' && selectedParticipant && refundForm.get('projectId')?.value) || 
                                      (selectedEnrollmentType === 'corporate' && selectedCorporateEnrollment && ((selectedPayerType === 'COMPANY') || (selectedPayerType === 'PARTICIPANT_CORPORATE' && selectedCorporateParticipant))))"
      class="bg-white p-6 rounded-lg shadow-sm">
      <h2 class="text-lg font-semibold text-gray-800 mb-4">Información de la Devolución</h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Concepto de Devolución -->
        <div class="md:col-span-2">
          <label for="refundConcept" class="block text-sm font-medium text-gray-700 mb-1">
            Concepto de Devolución <span class="text-red-500">*</span>
          </label>
          <input type="text" id="refundConcept" formControlName="refundConcept"
            class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ingrese el concepto de devolución">
          <div *ngIf="refundForm.get('refundConcept')?.invalid && refundForm.get('refundConcept')?.touched"
            class="text-red-500 text-sm mt-1">
            <span *ngIf="refundForm.get('refundConcept')?.errors?.['required']">Concepto de devolución es
              requerido</span>
            <span *ngIf="refundForm.get('refundConcept')?.errors?.['maxlength']">Máximo 200 caracteres</span>
          </div>
        </div>

        <!-- Banco -->
        <div>
          <label for="bankId" class="block text-sm font-medium text-gray-700 mb-1">
            Banco <span class="text-red-500">*</span>
          </label>
          <p-dropdown [options]="banks" formControlName="bankId" placeholder="Seleccione un banco" [filter]="true"
            filterBy="bankName" optionLabel="bankName" optionValue="id" [showClear]="true"
            class="w-full custom-dropdown">
          </p-dropdown>
          <div *ngIf="refundForm.get('bankId')?.invalid && refundForm.get('bankId')?.touched"
            class="text-red-500 text-sm mt-1">
            Banco es requerido
          </div>
        </div>

        <!-- Monto a Devolver -->
        <div>
          <label for="refundAmount" class="block text-sm font-medium text-gray-700 mb-1">
            Monto a Devolver <span class="text-red-500">*</span>
          </label>
          <input type="text" id="refundAmount" formControlName="refundAmount" appCurrencyFormatter
            class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            [ngClass]="{'border-red-500': refundForm.get('refundAmount')?.invalid && refundForm.get('refundAmount')?.touched}"
            placeholder="0"
            [attr.disabled]="isPlanRefund && (!planRefundLimits || !planRefundLimits.canRefund) ? true : null">
          <div *ngIf="refundForm.get('refundAmount')?.invalid && refundForm.get('refundAmount')?.touched"
            class="text-red-500 text-sm mt-1">
            <span *ngIf="refundForm.get('refundAmount')?.errors?.['required']">Monto es requerido</span>
            <span *ngIf="refundForm.get('refundAmount')?.errors?.['min']">Monto debe ser mayor a 0</span>
            <span *ngIf="refundForm.get('refundAmount')?.errors?.['maxRefundExceeded'] && isServiceRefund">
              El monto no puede exceder {{ maxRefundableAmount | currency:'COP':'symbol':'1.0-0' }} (máximo reembolsable
              para servicios)
            </span>
            <span
              *ngIf="refundForm.get('refundAmount')?.errors?.['maxRefundExceeded'] && isPlanRefund && planRefundLimits">
              <span *ngIf="!refundForm.get('refundAmount')?.errors?.['maxRefundExceeded']?.useRetractRight">
                El monto no puede exceder {{ planRefundLimits.availableToRefund |
                currency:planRefundLimits.currencyCode:'symbol':'1.0-0' }}
                ({{ planRefundLimits.maxRefundPercentage * 100 }}% del valor total de la inscripción)
              </span>
              <span *ngIf="refundForm.get('refundAmount')?.errors?.['maxRefundExceeded']?.useRetractRight">
                El monto no puede exceder {{ planRefundLimits.availableToRefundWithRetractRight |
                currency:planRefundLimits.currencyCode:'symbol':'1.0-0' }}
                (100% con derecho al retracto del valor total de la inscripción)
              </span>
            </span>
          </div>
          <!-- Ayuda para servicios -->
          <div *ngIf="isServiceRefund && maxRefundableAmount > 0" class="text-xs text-gray-500 mt-1">
            Monto máximo reembolsable: {{ maxRefundableAmount | currency:'COP':'symbol':'1.0-0' }}
          </div>
          <!-- Ayuda para plan de pagos con nueva lógica -->
          <div *ngIf="isPlanRefund && planRefundLimits && (planRefundLimits.canRefund || (isRetractRightActive && planRefundLimits.availableToRefundWithRetractRight > 0))"
            class="text-xs mt-1" [ngClass]="{
              'text-green-600': !isRetractRightActive,
              'text-blue-600': isRetractRightActive
            }">
            <i class="pi pi-check-circle mr-1"></i>
            <span *ngIf="!isRetractRightActive">
              Máximo disponible: {{ planRefundLimits.availableToRefund |
              currency:planRefundLimits.currencyCode:'symbol':'1.0-0' }}
              ({{ planRefundLimits.maxRefundPercentage * 100 }}% de {{ planRefundLimits.totalAmount |
              currency:planRefundLimits.currencyCode:'symbol':'1.0-0' }})
            </span>
            <span *ngIf="isRetractRightActive">
              Máximo disponible con derecho al retracto: {{ planRefundLimits.availableToRefundWithRetractRight |
              currency:planRefundLimits.currencyCode:'symbol':'1.0-0' }}
              (100% de {{ planRefundLimits.totalAmount |
              currency:planRefundLimits.currencyCode:'symbol':'1.0-0' }})
            </span>
          </div>
          <div *ngIf="isPlanRefund && planRefundLimits && !planRefundLimits.canRefund"
            class="text-xs text-red-500 mt-1">
            <i class="pi pi-exclamation-circle mr-1"></i>
            No hay monto disponible para devolución
          </div>
        </div>

        <!-- Justificación -->
        <div class="md:col-span-2">
          <label for="justification" class="block text-sm font-medium text-gray-700 mb-1">
            Justificación <span class="text-red-500">*</span>
          </label>
          <textarea id="justification" formControlName="justification" rows="3"
            class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ingrese la justificación para la devolución"></textarea>
          <div *ngIf="refundForm.get('justification')?.invalid && refundForm.get('justification')?.touched"
            class="text-red-500 text-sm mt-1">
            <span *ngIf="refundForm.get('justification')?.errors?.['required']">Justificación es requerida</span>
            <span *ngIf="refundForm.get('justification')?.errors?.['maxlength']">Máximo 1000 caracteres</span>
          </div>
        </div>

        <!-- Observaciones -->
        <div class="md:col-span-2">
          <label for="observations" class="block text-sm font-medium text-gray-700 mb-1">
            Observaciones
          </label>
          <textarea id="observations" formControlName="observations" rows="2"
            class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Observaciones adicionales (opcional)"></textarea>
          <div *ngIf="refundForm.get('observations')?.invalid && refundForm.get('observations')?.touched"
            class="text-red-500 text-sm mt-1">
            <span *ngIf="refundForm.get('observations')?.errors?.['maxlength']">Máximo 1000 caracteres</span>
          </div>
        </div>

        <!-- Solicitado por -->
        <div>
          <label for="requestedBy" class="block text-sm font-medium text-gray-700 mb-1">
            Solicitado por
          </label>
          <input type="text" id="requestedBy" formControlName="requestedBy"
            class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Nombre del solicitante">
          <div *ngIf="refundForm.get('requestedBy')?.invalid && refundForm.get('requestedBy')?.touched"
            class="text-red-500 text-sm mt-1">
            <span *ngIf="refundForm.get('requestedBy')?.errors?.['maxlength']">Máximo 100 caracteres</span>
          </div>
        </div>

        <!-- Número de documento personalizado -->

      </div>
    </div>

    <!-- Botones de acción -->
    <div *ngIf="selectedRefundType" class="bg-white p-6 rounded-lg shadow-sm">
      <div class="flex justify-end gap-4">
        <button type="button" (click)="onCancel()"
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition">
          <i class="pi pi-times mr-2"></i>
          Cancelar
        </button>

        <button type="submit" [disabled]="!isFormValidWithEnrollments"
          class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:bg-blue-300 disabled:cursor-not-allowed">
          <i class="pi pi-check mr-2"></i>
          Crear Devolución
        </button>
      </div>
    </div>

  </form>
</div>

<!-- Modal de Confirmación -->
<app-confirmation-modal #confirmationModal [isVisible]="showConfirmationModal" [config]="confirmationConfig"
  (confirmed)="onConfirmationModalConfirmed()" (cancelled)="onConfirmationModalCancelled()"
  (closed)="onConfirmationModalClosed()">
</app-confirmation-modal>